import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import getTranslationLanguageLabel from '../../../../../../utils/translation-language-label';
import { getCountryCode, MASTER_COUNTRY } from '../../model/library-mapper';

function LibraryUploadModal({
  isOpen,
  onClose,
  form,
  countryOptions,
  languageOptions,
  typeOptions,
  onUpdate,
  onSubmit,
  isSubmitting,
  isUploadDisabled,
  error,
  canUploadMasterEnglish,
  t,
}) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      className="library-upload-dialog"
      aria-labelledby="library-upload-dialog-title"
    >
      <DialogTitle id="library-upload-dialog-title">
        {t('library-modal-title')}
        <button
          type="button"
          className="library-upload-dialog__close"
          onClick={onClose}
          aria-label={t('common-close')}
        >
          <span className="icon-close" aria-hidden="true"></span>
        </button>
      </DialogTitle>

      <DialogContent>
        <div className="form-control">
          <label htmlFor="translation-file">{t('library-label-file')}</label>
          <div className="library-view__file-box">
            <label className="btn secondary small library-view__choose-file-button" htmlFor="translation-file">
              {t('library-upload-choose-file')}
            </label>
            <input
              id="translation-file"
              hidden
              type="file"
              accept=".xlsx"
              onChange={(event) => onUpdate('file', event.target.files?.[0] || null)}
            />
            {form.file ? (
              <span className="library-view__selected-file">{form.file.name}</span>
            ) : null}
            <span className="library-view__file-help">
              {t('library-upload-file-help')}
            </span>
          </div>
        </div>

        <div className="form-control">
          <label htmlFor="translation-country">{t('library-label-country')}</label>
          <select
            id="translation-country"
            className="normal"
            value={form.country}
            onChange={(event) => onUpdate('country', event.target.value)}
            disabled={!canUploadMasterEnglish && countryOptions.length === 1}
          >
            <option value="">{t('library-placeholder-country')}</option>
            {canUploadMasterEnglish ? (
              <option value={MASTER_COUNTRY}>{t('library-master-country')}</option>
            ) : null}
            {countryOptions.map((country) => (
              <option key={country} value={country}>
                {t(`countries-${getCountryCode(country)}`, { defaultValue: country })}
              </option>
            ))}
          </select>
        </div>

        <div className="form-control">
          <label htmlFor="translation-language">{t('library-label-language')}</label>
          <select
            id="translation-language"
            className="normal"
            value={form.language}
            onChange={(event) => onUpdate('language', event.target.value)}
            disabled={!form.country || languageOptions.length === 1}
          >
            <option value="">{t('library-placeholder-language')}</option>
            {languageOptions.map((language) => (
              <option key={language} value={language}>
                {getTranslationLanguageLabel(language, getCountryCode(form.country), t)}
              </option>
            ))}
          </select>
        </div>

        <div className="form-control">
          <label htmlFor="translation-type">{t('library-label-type')}</label>
          <select
            id="translation-type"
            className="normal"
            value={form.type}
            onChange={(event) => onUpdate('type', event.target.value)}
          >
            <option value="">{t('library-placeholder-type')}</option>
            {typeOptions.map((type) => (
              <option key={type.value} value={type.value}>
                {t(type.labelKey)}
              </option>
            ))}
          </select>
        </div>

        {error ? <div className="library-view__error" role="alert">{error}</div> : null}
      </DialogContent>

      <DialogActions>
        <button type="button" className="btn secondary small" onClick={onClose}>
          {t('common-cancel')}
        </button>
        <button type="button" className="btn small" onClick={onSubmit} disabled={isUploadDisabled}>
          {isSubmitting ? t('library-button-uploading') : t('library-button-add')}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default LibraryUploadModal;
